import React from 'react';

/** Lazy ClientComputedMandatoryRead (not wrapped in a suspense to use the parent widget loading fallback) */
export const ClientComputedMandatoryRead = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'widget-mandatory-read' */
            './ConnectedMandatoryRead'
        ),
);
